import { FieldType, DefaultFormTableSchema } from "./types";
export class ApplicationCustomersSchema extends DefaultFormTableSchema {
    constructor() {
        super({
            tableData: {
                isReadOnlyRow: (rowData, cells) => rowData?.engagementCustomerId &&
                    rowData.engagementCustomerId !== rowData.customerId
            },
            columnData: {
                phoneMobile: {
                    fieldType: FieldType.Text,
                    isRequired: true,
                    // Disable and hide value if mainCustomer
                    isEditableFunctions: {
                        EditableIfNotMainCustomer: form => {
                            const isMainCustomer = form.values["isMainCustomer"];
                            return !isMainCustomer;
                        }
                    },
                    displayValue: (value, rowData) => {
                        return rowData.isMainCustomer ? "" : value;
                    }
                },
                email: {
                    fieldType: FieldType.Text,
                    isRequired: true,
                    // Disable and hide value if mainCustomer
                    isEditableFunctions: {
                        EditableIfNotMainCustomer: form => {
                            const isMainCustomer = form.values["isMainCustomer"];
                            return !isMainCustomer;
                        }
                    },
                    displayValue: (value, rowData) => {
                        return rowData.isMainCustomer ? "" : value;
                    }
                },
                customerNumber: {
                    fieldType: FieldType.Text,
                    isRequired: true
                },
                customerRole: {
                    fieldType: FieldType.Select,
                    isRequired: true
                },
                isResident: {
                    fieldType: FieldType.Checkbox,
                    hide: (value, rowData, cells, isPlaceholder, firstInGroup) => {
                        const role = rowData["customerRole"];
                        return role !== 12;
                    },
                    isEditableFunctions: {
                        EditableIfHouseOwner: (form, row) => {
                            const role = row.find(c => c.column.id === "customerRole")
                                ?.value;
                            return role === 12;
                        }
                    }
                }
            }
        });
    }
}
//# sourceMappingURL=ApplicationCustomersSchema.js.map